(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawkoda-cat-kit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-cat-kit')) {
    customElements.define('pk-cat-kit', class extends HTMLElement {
      connectedCallback() {
        this.discount = Number(this.dataset.discount) || 0;
        this.button = this.querySelector('[data-kit-add]');
        this.error = this.querySelector('[data-kit-error]');
        this.addEventListener('change', (event) => this.onChange(event));
        if (this.button) this.button.addEventListener('click', () => this.addKit());
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }

      onChange(event) {
        const input = event.target;
        if (!input.matches('[data-kit-variant]')) return;
        const item = input.closest('[data-kit-item]');
        item.dataset.price = input.dataset.price;
        item.querySelector('[data-kit-item-price]').textContent = this.formatMoney(Number(input.dataset.price));
        const image = item.querySelector('.pk-kit__media img');
        if (image && input.dataset.image) {
          image.removeAttribute('srcset');
          image.src = input.dataset.image;
        }
        this.updateTotals();
      }

      updateTotals() {
        const prices = [...this.querySelectorAll('[data-kit-item]')].map((item) => Number(item.dataset.price));
        const total = prices.reduce((sum, price) => sum + price, 0);
        const saving = prices.reduce((sum, price) => sum + Math.floor((price * this.discount) / 100), 0);
        this.querySelector('[data-kit-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-kit-final]').textContent = this.formatMoney(total - saving);
        this.querySelector('[data-kit-saving]').textContent = this.formatMoney(saving);
      }

      selectedItems() {
        return [...this.querySelectorAll('[data-kit-item]')].map((item) => {
          const input = item.querySelector('[data-kit-variant]:checked, input[type="hidden"][data-kit-variant]');
          return input ? { id: Number(input.value), quantity: 1 } : null;
        });
      }

      async addKit() {
        const items = this.selectedItems();
        if (items.includes(null)) {
          this.showError('Please choose an option for each item.');
          return;
        }
        this.button.disabled = true;
        this.error.hidden = true;
        try {
          const response = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add the kit to your cart.');
          window.location.href = this.dataset.redirect === 'checkout' ? '/checkout' : '/cart';
        } catch (err) {
          this.showError(err.message);
          this.button.disabled = false;
        }
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
